export const BONUS_POP_CODE = '262';
export const REBATE_CODE = '2RC';
